export enum CookDetailTypeEnumChefForParty {
    MAIN_CHEF = "MAIN_CHEF",
    ASSISTANT_CHEF = "ASSISTANT_CHEF",
    BARTENDER = "BARTENDER",
    WAITER = "WAITER",
  }